export const errorMessage = 'Something went wrong. Please try again.';
export const noDataMessage = 'No data. Something went wrong. Please try again.';
export const pageTitle = 'Transaction Details';
